export default __webpack_public_path__ + "imgs/fcc58c4b2acf5fe7d231c959d74c63c7.png";